// Centralized title color mapping to keep gradient/color logic DRY
export const titleColorMap: Record<string, string> = {
  "lessonlab": "hsl(var(--lesson-lab))",
  "writingwizard": "hsl(var(--blue-gradient))",
  researcher: "hsl(var(--research))",
  "resourcerefinery": "hsl(var(--resource-crust))",
  "catchupcoach": "hsl(var(--catchup-coach))",
};

export function getTitleColor(title?: string): string {

  if (!title) return "hsl(var(--blue-gradient))";
  return titleColorMap[title.replace(" ", "").toLowerCase()] || "hsl(var(--blue-gradient))";
}
